import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plus, Search } from 'lucide-react';
import classes from '../glossary.module.scss';
import { createCn } from '../../../helpers/utils';

const cn = createCn('glossary', classes);

export type LanguageFilter = 'all' | 'ru' | 'kk' | 'en';
export type ActiveFilter = 'all' | 'active' | 'inactive';

interface GlossaryToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  languageFilter: LanguageFilter;
  onLanguageFilterChange: (value: LanguageFilter) => void;
  activeFilter: ActiveFilter;
  onActiveFilterChange: (value: ActiveFilter) => void;
  count: number;
  onAdd: () => void;
}

const GlossaryToolbar = ({
  search,
  onSearchChange,
  languageFilter,
  onLanguageFilterChange,
  activeFilter,
  onActiveFilterChange,
  count,
  onAdd,
}: GlossaryToolbarProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('toolbar')}>
      <div className={cn('search')}>
        <span className={cn('search-icon')}><Search size={16} /></span>
        <input
          type="text"
          className={cn('search-input')}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('glossary.search-placeholder') as string}
          aria-label={t('glossary.search-placeholder') as string}
        />
      </div>

      <div className={cn('filter')}>
        <label htmlFor="glossary-filter-language">{t('glossary.filter-language-label')}</label>
        <select
          id="glossary-filter-language"
          value={languageFilter}
          onChange={(e) => onLanguageFilterChange(e.target.value as LanguageFilter)}
        >
          <option value="all">{t('glossary.filter-language-all')}</option>
          <option value="ru">Русский</option>
          <option value="kk">Қазақша</option>
          <option value="en">English</option>
        </select>
      </div>

      <div className={cn('filter')}>
        <label htmlFor="glossary-filter-active">{t('glossary.filter-active-label')}</label>
        <select
          id="glossary-filter-active"
          value={activeFilter}
          onChange={(e) => onActiveFilterChange(e.target.value as ActiveFilter)}
        >
          <option value="all">{t('glossary.filter-active-all')}</option>
          <option value="active">{t('glossary.filter-active-active')}</option>
          <option value="inactive">{t('glossary.filter-active-inactive')}</option>
        </select>
      </div>

      <div className={cn('spacer')} />

      <div className={cn('count')}>{t('glossary.count', { count })}</div>

      <button type="button" className={cn('add-btn')} onClick={onAdd}>
        <Plus size={16} /> {t('glossary.add-button')}
      </button>
    </div>
  );
};

export default GlossaryToolbar;
